import { useState, useEffect, forwardRef } from 'react';
import { CoreIcon } from '@autopass-web/mochi-icons';
import FormInput from '../form-input/form-input';
import classnames from 'classnames/bind';
import styles from './index.module.sass';
import DataList from '../data-list/data-list';

const cx = classnames.bind(styles);

interface SearchListProps {
  data: [];
  filter: (data: []) => any;
  render: () => void;
  onSelect: (value: string) => void;
  placeholder: string;
  value: string;
  onChange?: (value: []) => void;
  onFocus: () => void;
  errorMessage: string;
}

const SearchList = forwardRef<HTMLInputElement, SearchListProps>(
  (
    {
      data,
      filter,
      render,
      onSelect,
      placeholder,
      value = '',
      onChange,
      onFocus,
      errorMessage,
    },
    ref,
  ) => {
    const [values, setValues] = useState<any>(value);
    const [currentValue, setCurrentValue] = useState<any>(value);
    const [selected, setSelected] = useState('');
    const [showDropdown, setShowDropdown] = useState(false);
    const [filteredData, setFilteredData] = useState(data);

    useEffect(() => {
      setValues(value);
    }, [value]);

    const onTextChanged = (value: any) => {
      // set data
      if (value.length === 0) {
        setFilteredData(() => data);
      } else {
        setFilteredData(() => {
          return filter(value); // 調整外部 filter
        });
      }
      setValues(value);
      if (onChange) onChange(value);
    };

    const onFocusHandler = () => {
      if (onFocus) onFocus();
      setValues('');
      setShowDropdown(true);
    };

    const onSelectHandler = (key: string) => {
      const selectValue = () => {
        const getValue = (data: []) => {
          const result: { value: [] } = data.find(
            (x: { key: string }) => x.key === key,
          ) || { value: [] };
          return result.value;
        };

        if (typeof getValue(data) === 'string') return getValue(data);
        return getValue(data).join(' ');
      };
      setValues(() => selectValue());
      setCurrentValue(() => selectValue());
      setFilteredData(() => data);
      setSelected(key);
      setShowDropdown(false);
      onSelect(key);
    };

    const onBlurHandler = () => {
      setFilteredData(() => data);
      setValues(currentValue);
      setShowDropdown(false);
    };

    const maskClass = cx({
      mask: true,
      visible: showDropdown,
    });

    return (
      <div className={styles['search-list']}>
        <div className={maskClass} onClick={onBlurHandler} />
        <FormInput
          appearance="grey"
          placeholder={placeholder}
          value={values}
          onFocus={onFocusHandler}
          onTextChange={onTextChanged}
          behindValue={<CoreIcon src="../../assets/icon_spin.svg" />}
          ref={ref}
          errorMessage={errorMessage}
        />
        <DataList
          selectedKey={selected}
          data={filteredData}
          show={showDropdown}
          onSelect={onSelectHandler}
          withIcon={false}
          render={render}
        />
      </div>
    );
  },
);

export default SearchList;
